module.exports = (__parcel__import__("9SDpi")).then(() => parcelRequire('fyWP3'));